import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqList } from "@/mocks/doujinData";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>("faq-01");

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="container-x max-w-4xl">
        <SectionHeading
          eyebrow="常见问题"
          title="关于在线浏览，你可能想了解"
          desc="整理了大家最常问到的问题，帮助你更快上手同人本子的在线浏览体验。"
        />

        <div className="space-y-3">
          {faqList.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-xl bg-background-100 border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-950">
                    {item.question}
                  </h3>
                  <span
                    className={`w-7 h-7 flex items-center justify-center shrink-0 rounded-full transition-all ${
                      isOpen
                        ? "bg-primary-500 text-background-50 rotate-45"
                        : "bg-background-50 text-foreground-700"
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}